export const garagisteSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.groupefabre-environnement.fr/nos-metiers/garagiste#service",
  "name": "Gestion des déchets automobiles - Solutions pour garagistes",
  "description": "Solutions complètes de gestion des déchets automobiles pour garages et ateliers mécaniques. Collecte huiles usagées, batteries, pneus, pièces métalliques. Conformité réglementaire garantie.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Groupe Fabre Environnement",
    "url": "https://www.groupefabre-environnement.fr",
    "telephone": "+33565787900",
    "email": "contactgfe@groupefabre.com",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "127"
    }
  },
  "serviceType": "Gestion des déchets automobiles",
  "category": ["Recyclage automobile", "Gestion déchets dangereux", "Valorisation métaux"],
  "audience": {
    "@type": "Audience",
    "audienceType": "Garagistes, mécaniciens, concessionnaires automobiles"
  },
  "areaServed": [
    "Aveyron", "Cantal", "Haute-Garonne", "Tarn", "Lot", "Lozère", "Puy-de-Dôme", "Val-d'Oise"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Services déchets automobiles",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Collecte huiles usagées",
          "description": "Collecte et traitement réglementaire des huiles moteur et liquides de freins"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Gestion batteries automobiles",
          "description": "Collecte et recyclage des batteries au plomb et accumulateurs"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Collecte pneus usagés",
          "description": "Enlèvement et valorisation des pneumatiques en fin de vie"
        }
      }
    ]
  }
};

export const wasteSolutions = [
  {
    icon: "Droplets",
    title: "Huiles usagées et liquides",
    description: "Collecte réglementaire des huiles moteur, liquides de freins, de refroidissement et hydrauliques",
    solutions: [
      "Bacs étanches conformes",
      "Collecte programmée",
      "Valorisation énergétique",
      "Bordereaux de suivi"
    ],
    benefit: "Protection des sols et nappes phréatiques",
    regulation: "Conformité ICPE et réglementation ADR"
  },
  {
    icon: "Battery",
    title: "Batteries et accumulateurs",
    description: "Gestion complète des batteries au plomb, lithium et autres accumulateurs automobiles",
    solutions: [
      "Bacs anti-acide sécurisés",
      "Collecte par véhicule agréé",
      "Recyclage du plomb",
      "Récupération électrolyte"
    ],
    benefit: "99% du plomb recyclé, évite pollution acide",
    regulation: "Respect directive européenne 2006/66/CE"
  },
  {
    icon: "Circle",
    title: "Pneus et pneumatiques",
    description: "Solutions complètes pour la gestion des pneus usagés de tous véhicules",
    solutions: [
      "Collecte sur site",
      "Tri par catégories",
      "Valorisation en granulats",
      "Combustible alternatif"
    ],
    benefit: "100% valorisés, évite stockage sauvage",
    regulation: "Conformité éco-organisme Aliapur"
  },
  {
    icon: "Wrench",
    title: "Pièces métalliques",
    description: "Valorisation optimale des métaux ferreux, non-ferreux et catalyseurs",
    solutions: [
      "Bennes dédiées métal",
      "Rachat catalyseurs",
      "Tri magnétique",
      "Fonte d'aluminium"
    ],
    benefit: "Récupération métaux précieux et économies",
    regulation: "Traçabilité complète des métaux"
  }
];

export const advantages = [
  {
    icon: "CheckCircle",
    title: "Conformité garantie",
    description: "Respect total de la réglementation ICPE et des obligations environnementales"
  },
  {
    icon: "Award",
    title: "Expertise automobile",
    description: "25 ans d'expérience dans la gestion des déchets du secteur automobile"
  },
  {
    icon: "Recycle",
    title: "Valorisation maximale",
    description: "Taux de valorisation de 95% pour optimiser vos coûts et l'environnement"
  },
  {
    icon: "PhoneCall",
    title: "Service réactif",
    description: "Intervention sous 48h et service client dédié aux professionnels"
  }
];

export const testimonials = [
  {
    name: "Michel Durand",
    company: "Garage de la Vallée",
    content: "Service impeccable depuis 5 ans. La collecte est toujours ponctuelle et la gestion administrative simplifiée.",
    rating: 5
  },
  {
    name: "Sylvie Moreau", 
    company: "Auto Services Plus",
    content: "Excellent accompagnement pour la mise en conformité. L'équipe est professionnelle et de bon conseil.",
    rating: 5
  }
];